import styled from 'styled-components';

export const ContentPage = styled.div`
    padding: 32px 24px;

    h1 {
        margin-bottom: 44px;
    }

    h2 {
        font-size: 24px;
        margin-bottom: 12px;
    }

`